/**
 * ** DO NOT USE THIS FILE IN NEW CODE **
 * ** DO NOT ADD NEW CODE TO THIS FILE **
 * ** This file will be removed in the future **
 *
 * @deprecated This file is a wrapper for `@tenants/types/theme` and
 * is used to provide backwards compatibility with the old theme types.
 */
import {
  ThemeNames as TenantThemeNames,
  Themes as ThemesType,
  EXPREALTY_US_THEME_NAME as EXP_REALTY_US,
  EXPREALTY_CA_THEME_NAME as EXP_REALTY_CA,
  ZOOCASA_THEME_NAME as ZOOCASA,
  EXP_IN_SERVICE_THEME_NAME as EXP_IN_SERVICE,
  EXP_COMMERCIAL_THEME_NAME as EXP_COMMERCIAL,
} from '@tenants/types';

/** @deprecated Use {@link EXP_REALTY_US EXPREALTY_US_THEME_NAME} from `@tenants/types` instead. */
export const EXPREALTY_US_THEME_NAME = EXP_REALTY_US;
/** @deprecated Use {@link EXP_REALTY_CA EXPREALTY_CA_THEME_NAME} from `@tenants/types` instead. */
export const EXPREALTY_CA_THEME_NAME = EXP_REALTY_CA;
/** @deprecated Use {@link ZOOCASA ZOOCASA_THEME_NAME} from `@tenants/types` instead. */
export const ZOOCASA_THEME_NAME = ZOOCASA;
/** @deprecated Use {@link EXP_IN_SERVICE EXP_IN_SERVICE_THEME_NAME} from `@tenants/types` instead. */
export const EXP_IN_SERVICE_THEME_NAME = EXP_IN_SERVICE;
/** @deprecated Use {@link EXP_COMMERCIAL EXP_COMMERCIAL_THEME_NAME} from `@tenants/types` instead. */
export const EXP_COMMERCIAL_THEME_NAME = EXP_COMMERCIAL;

/** @deprecated Use {@link TenantThemeNames ThemeNames} from `@tenants/types` instead. */
export const ThemeNames = TenantThemeNames;

/** @deprecated Use {@link TenantThemeNames ThemeNames} from `@tenants/types` instead. */
export type ThemeNames = TenantThemeNames;

/** @deprecated Use {@link ThemesType Themes} from `@tenants/types` instead. */
export type Themes = ThemesType;